/**
 * Shared responsive thresholds.
 *
 * The navbar swaps to its hamburger menu below this width. The sidebar uses the
 * same number so the two never disagree: before this was shared, the navbar went
 * mobile at 1000px while the permanent sidebar stayed visible at any width, so a
 * phone showed two competing navigations and the sidebar ate 250px of a 375px
 * screen.
 *
 * Not a named MUI breakpoint because it isn't one — `md` is 900 and `lg` is 1200,
 * and the navbar's layout genuinely needs the switch at 1000.
 */
export const MOBILE_NAV_BREAKPOINT = 1000;

export default MOBILE_NAV_BREAKPOINT;
